import React from "react";
import { Bounce, toast } from "react-toastify";

export const createNotification = (
  type: string,
  title: string | null = null,
  message: string | null = null,
  timeout = 6000,
) => {
  const options = {
    autoClose: timeout,
    hideProgressBar: false,
    closeOnClick: false,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    theme: "colored",
    transition: Bounce,
    style: {
      width: "fit-content",
    },
  };

  const formatMessage = (msg: string) => {
    if (msg.includes("\n")) {
      const lines = msg.split("\n");
      return (
        <div>
          {lines.map((line, index) => {
            if (line.trim() === "") {
              return <br key={index} />;
            }
            if (line.startsWith("•")) {
              return (
                <div
                  key={index}
                  style={{ marginLeft: "10px", marginBottom: "3px" }}
                >
                  {line}
                </div>
              );
            }
            return <div key={index}>{line}</div>;
          })}
        </div>
      );
    }
    return <span>{msg}</span>;
  };

  const content = (
    <div>
      {title && <h5 style={{ marginBottom: "8px" }}>{title}</h5>}
      {message && (
        <div style={{ marginBottom: 0 }}>{formatMessage(message)}</div>
      )}
    </div>
  );

  switch (type) {
    case "info":
      toast.info(content, options);
      break;
    case "success":
      toast.success(content, options);
      break;
    case "warning":
      toast.warning(content, options);
      break;
    case "error":
      toast.error(content, options);
      break;
  }
};
